<template>
  <div class="productionModel">
    <div class="basic_info" ref="bascInfo">
      <div class="title">{{$t('other.a1239')}}</div>
      
      <div class="basic_detail">
        <el-form
          :model="productDTO"
          
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <!-- <el-form-item :label="$t('other.a1364')"  prop="country">
                        <el-select style="width:250px" ref="searchSelect"    v-model="ruleForm.country"   :placeholder="$t('other.a644')">
                            <el-option
                            v-for="item in countryOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item> -->
          <el-form-item :label="$t('other.a1240')" prop="sourceUrl">
            <el-input
              type="textarea"
              autosize
              :placeholder="$t('other.a319')"
              v-model="productDTO.productUrl"
            >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a179')" prop="name">
            <el-input
              type="textarea"
              autosize
              :placeholder="$t('other.a319')"
              v-model="productDTO.productName"
            >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a1241')" prop="description">
            <el-input
              type="textarea"
              autosize
              :placeholder="$t('other.a319')"
              v-model="productDTO.productDescription"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="basic_info">
      <div class="title" ref="photo">{{$t('other.a1265')}}</div>
      <div class="basic_detail">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('other.a1242')" prop="name">
            <draggable
              class=""
              v-model="ruleForm.images"
              tag="ul"
              v-bind="dragOptions"
              @start="ruleForm.drag = true"
              @end="ruleForm.drag = false"
            >
              <span
                v-for="(item, index) in ruleForm.images"
                :key="index"
                :class="{ listitem: true }"
                @click="showDelBtn(index)"
                @mouseenter="indexOne = index"
                @mouseleave="indexOne = -1"
              >
                <img v-show="item.image" :src="item.image" class="pic_box" />
                <div
                  v-show="item.image"
                  :class="{ delete: true, deleteActive: indexOne == index }"
                  @click.stop="deleteImg(index)"
                >
                  {{$t('other.a312')}}
                </div>
                <span class="pic_desc">{{
                  index == 0 ? $t('other.a1266') : $t('other.a66') + index
                }}</span>
              </span>
            </draggable>
            <el-upload
              action=""
              multiple
              style="filter: alpha(opacity=0); opacity: 0"
              list-type="picture-card"
              :http-request="handleUploadHttpRequest"
              :on-success="handlePictureSuccess"
              :show-file-list="false"
            >
              <el-button id="initSlide" type="primary">{{$t('other.a368')}}</el-button>
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="basic_info">
      <div class="title" ref="logistic">{{$t('other.a1267')}}</div>
      <el-button @click="addValue">{{$t('other.a1268')}}</el-button>
      <div class="basic_detail">
        <el-table border :data="productDTO.productAttributes" style="width: 100%">
          <el-table-column prop="attributeName" :label="$t('other.a1243')" width="180">
            <template slot-scope="props">
              <el-input v-model="props.row.attributeName"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="attributeValue" :label="$t('other.a1111')" width="180">
            <template slot-scope="props">
              <el-input v-model="props.row.attributeValue"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="attributeType" :label="$t('other.a1244')">
            <template slot-scope="props">
              <el-radio v-model="props.row.attributeType" label="0"
                >{{$t('other.a1269')}}</el-radio
              >
              <el-radio v-model="props.row.attributeType" label="1"
                >{{$t('other.a1270')}}</el-radio
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="basic_info" ref="variations">
      <div class="title">{{$t('other.a1271')}}</div>
      <div class="basic_detail">
        <el-form
          :model="productDTO"
          
          ref="productDTO"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('other.a1273')" prop="variation">
            <el-radio v-model="radio" label="1" disabled >{{$t('other.a251')}}</el-radio>
            <el-radio v-model="radio" label="2" disabled >{{$t('other.a1272')}}</el-radio>
          </el-form-item>
          <!-- <el-form-item v-show=" radio == '2'"  :label="$t('other.a1366')" >
                        <div>
                            <el-input style="width:250px" type="text" v-model="addAttribute" :placeholder="$t('other.a1367')"></el-input>
                            <el-button style="margin:0 10px" type="primary" @click="addAttibuteItem()">{{$t('other.a1382')}}</el-button>
                        </div>
                        <div class="attribute"  v-for="(item,index) in ruleForm.tiers" :key="index">
                            <div class="fist_title_wrapper">
                                <div>
                                    <span v-show="!item.checked02" class="fist_title">{{item.name}}</span>
                                    <input v-show="item.checked02" v-model="item.name" placeholder="" />
                                    <i v-show="!item.checked02" class="el-icon-edit" @click="vkfb(item,index)"></i>
                                    <i v-show="item.checked02" class="el-icon-check" @click="confirmvkfb(item,index)"></i>
                                </div>
                                <span style="color:#409EFF;cursor: pointer" @click="delAttItem(index)">{{$t('other.a312')}}</span>
                            </div>
                            <div>
                                <span class="category_item" v-for="(firstItem,index02) in item.listItem" :key="index02">
                                   
                                    <span v-show="!firstItem.checked02">{{firstItem.name}}</span>
                                    <input class="kvnnf" v-show="firstItem.checked02" v-model="firstItem.name" placeholder="" />
                                    <i v-show="!firstItem.checked02" class="el-icon-edit" @click="onhv(firstItem,index,index02)"></i>
                                   
                                    <i v-show="firstItem.checked02" class="el-icon-check" @click="fixAttr(firstItem,index,index02)"></i>
                                    <i v-show="firstItem.checked02" class="el-icon-circle-close" @click="delAttr(index,index02)"></i>
                                </span>
                                
                            </div>
                        <div>
                                <el-input style="width:150px" size="mini" type="text" v-model="item.firstCategory" :placeholder="$t('other.a1247')"></el-input>
                                <el-button style="margin:0 10px" size="mini" @click.stop="addOtherspp(index)">{{$t('other.a1081')}}</el-button>
                        </div>
                        </div>
                    </el-form-item> -->

          <!-- <el-form-item  width="250"  :label="$t('other.a735')" prop="psku">
                        <div>
                            <el-input style="width:350px"  v-model="ruleForm.itemSku" :placeholder="$t('other.a298')"></el-input>
                            
                        </div>
                    </el-form-item> -->
          <el-form-item :label="$t('other.a1245')" prop="variations">
            <div v-if="radio == '2'">
              <el-input
                style="width: 350px"
                v-model="productDTO.productSku"
                :placeholder="$t('other.a1246')"
              ></el-input>
              <el-input
                style="width: 150px"
                size="mini"
                type="text"
                v-model="property"
                :placeholder="$t('other.a1247')"
              ></el-input>
              <el-button
                style="margin: 0 10px"
                size="mini"
                @click.stop="addattribute"
                >{{$t('other.a1081')}}</el-button
              >

              <el-table
                :data="productDTO.productSkuList"
                
                border
                style="width: 100%"
              >
                <!-- <el-table-column width="80">
                                 <template slot-scope="props">
                                    <i v-show="props.$index == 0" @click="addItmes(0,props.$index)" class="iconfont icon-zengjiatianjiajiajian"></i>
                                    <i v-show="!props.$index == 0" @click="addItmes(1,props.$index)" class="iconfont icon-jianshao1"></i>
							    </template>
                            </el-table-column> -->
                <!-- <el-table-column >
                                 <template slot-scope="props">
                                    <el-input v-model="ruleForm.tiers.name"></el-input>
                                    
							    </template>
                            </el-table-column> -->
                <!-- <el-table-column   :label="ruleForm.tiers[1].name">
                                 <template slot-scope="props">
                                    <span>{{ruleForm.tiers[1].optionArray[props.row.tierIndex[1]]}}</span>
                                    
							    </template>
                            </el-table-column> -->
                <el-table-column>
                  <template slot-scope="scope" slot="header">
                    <span style="padding-right: 25px">{{$t('other.a1274')}}</span>
                  </template>
                  <template slot-scope="props">
                    <el-input
                      v-model="props.row.skuName"
                      :placeholder="props.row.skuName"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope" slot="header">
                    <span style="padding-right: 25px">{{$t('other.a1275')}}</span>
                    <el-input
                      size="mini"
                      style="width: 120px"
                      @blur="setPrice(1)"
                      v-model="priceValue"
                      :placeholder="$t('other.a1248')"
                    ></el-input>
                  </template>
                  <template slot-scope="props">
                    
                    <el-input
                      
                      @blur="getDataType(props.row.estimatedPurchasePrice)"
                      v-model="props.row.estimatedPurchasePrice"
                      :placeholder="props.row.estimatedPurchasePrice"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="date" width="200" :label="$t('other.a310')">
                  <template slot-scope="scope" slot="header">
                    <span style="padding-right: 25px">{{$t('other.a310')}}</span>
                    <el-input
                      size="mini"
                      style="width: 120px"
                      @blur="setPrice(2)"
                      v-model="stockValue"
                      :placeholder="$t('other.a1248')"
                    ></el-input>
                  </template>
                  <template slot-scope="props">
                    <el-input
                      @blur="props.row.inventory = Number(props.row.inventory)"
                      v-model="props.row.inventory"
                      :placeholder="$t('other.a1249')"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="date" :label="$t('other.a1251')">
                  <template slot-scope="props">
                    <el-input
                      v-model="props.row.skuName"
                      :placeholder="$t('other.a1250')"
                    ></el-input>
                  </template>
                </el-table-column>
                
              </el-table>
            </div>

            <div v-if="radio == '1'" class="singSku_wrapper">
              <div class="singSku">
                <span>skuName：</span>
                <el-input
                  class="inputBox"
                  v-model="productDTO.productSkuList[0].skuName"
                  placeholder="sku"
                ></el-input>
              </div>
              <div class="singSku">
                <span>{{$t('other.a831')}}：</span>
                <el-input
                  class="inputBox"
                  v-model="productDTO.productSkuList[0].estimatedPurchasePrice"
                  :placeholder="$t('other.a1252')"
                ></el-input>
              </div>
              <div class="singSku">
                <span>{{$t('other.a310')}}：</span>
                <el-input
                  class="inputBox"
                  v-model="productDTO.productSkuList[0].inventory"
                  :placeholder="$t('other.a310')"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="basic_info">
      <div class="title" ref="logistic">{{$t('other.a1276')}}</div>
      <div class="basic_detail">
        <el-form
          :model="productDTO"
          ref="productDTO"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('other.a1253')" prop="weight">
            <el-input
              @blur="productDTO.productLogistic.weight = Number(productDTO.productLogistic.weight)"
              style="width: 250px; margin-right: 15px"
              v-model="productDTO.productLogistic.weight"
            ></el-input>
            <span>KG</span>
          </el-form-item>
          <el-form-item :label="$t('other.a1254')" prop="name">
            <el-input
              @blur="productDTO.productLogistic.length = Number(productDTO.productLogistic.length)"
              style="width: 80px; margin-right: 15px"
              v-model="productDTO.productLogistic.length"
              :placeholder="$t('other.a1255')"
            ></el-input>
            <el-input
              @blur="productDTO.productLogistic.wide = Number(productDTO.productLogistic.wide)"
              style="width: 80px; margin-right: 15px"
              v-model="productDTO.productLogistic.wide"
              :placeholder="$t('other.a1256')"
            ></el-input>
            <el-input
              @blur="productDTO.productLogistic.height = Number(productDTO.productLogistic.height)"
              style="width: 80px; margin-right: 15px"
              v-model="productDTO.productLogistic.height"
              :placeholder="$t('other.a1257')"
            ></el-input>
            <span>CM</span>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="basic_info">
      <div class="title" ref="logistic">{{$t('other.a1277')}}</div>
      <div class="basic_detail">
        <el-form
          :model="productDTO"
          ref="productDTO"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('other.a1258')" prop="weight">
            <el-input
              @blur="
                productDTO.estimateProfit = Number(productDTO.estimateProfit)
              "
              style="width: 250px; margin-right: 15px"
              v-model="productDTO.estimateProfit"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a1259')" prop="weight">
            <!-- <el-input  style="width:250px;margin-right:15px" v-model="productDTO.isQualityTest"></el-input> -->
            <el-select v-model="productDTO.isQualityTest" :placeholder="$t('other.a50')">
              <el-option
                v-for="item in optionsQue"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('other.a1260')" prop="weight">
            <el-input
              style="width: 250px; margin-right: 15px"
              v-model="productDTO.productKeyWord"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('other.a1346')" prop="weight">
                        <el-input  style="width:250px;margin-right:15px" v-model="productDTO.productStatus"></el-input>
                       
                    </el-form-item> -->
          <el-form-item :label="$t('other.a1261')" prop="weight">
            <el-input
              style="width: 250px; margin-right: 15px"
              v-model="productDTO.salesStatus"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a1262')" prop="weight">
            <el-input
              style="width: 250px; margin-right: 15px"
              @blur="productDTO.purchaseCost = Number(productDTO.purchaseCost)"
              v-model="productDTO.purchaseCost"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a1263')" prop="weight">
            <el-select
                                    v-model="productDTO.supplier"
                                    :placeholder="$t('other.a1113')"
                                   
                                   
                                >
                                    <el-option
                                    v-for="item in supplierData"
                                    :key="item.id"
                                    :label="item.supplier"
                                    :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
          </el-form-item>
          <el-form-item :label="$t('other.a1264')" prop="weight">
            <el-select
                                
                                v-model="productDTO.warehouse"
                                :placeholder="$t('other.a914')"
                               
                            >
                                <el-option
                                v-for="item in warehouseOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                                </el-option>
                            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="footer">
      
     
      <div style="margin-right:50px">
        <el-button
          
          type="primary"
          @click="addProducts()"
          >{{$t('other.a1278')}}</el-button
        >
      </div>
       <div style="margin-right:50px"><el-button type="primary" @click="back">{{$t('other.a1279')}}</el-button></div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api";
import userStoreItemsApi from "../../api/moudles/userStoreItems";
import draggable from "vuedraggable";
import { mapState, mapMutations } from "vuex";
import { resolve } from "path";
// import userstoreitemsTabVue from '../overseas/userstoreitemsTab.vue'
import utils from "../../utils/utils";
import jsonp from "../../api/jsonp";
export default {
  data() {
    return {
       supplierData:[],
    warehouseOption:[],
      property: "",
      optionsQue: [
        {
          value: "is_quality_test",
          label: this.$t('other.a1280'),
        },
        {
          value: "no_quality_test",
          label: this.$t('other.a1281'),
        },
      ],
      productDTO: {
        createdTime: "2021-09-13T06:23:16.907Z",
        estimateProfit: 0,
        isQualityTest: "no_quality_test",
        itemSkuType: 1,
        productAttributes: [
          {
            attributeId: "string",
            attributeName: "string",
            attributeType: 0,
            attributeValue: "string",
            attributeValues: [
              {
                attributeId: "string",
                attributeName: "string",
                attributeValue: "string",
                attributeValueId: "string",
                createdTime: "2021-09-13T06:23:16.912Z",
                productId: "string",
                updatedTime: "2021-09-13T06:23:16.912Z",
              },
            ],
            createdTime: "2021-09-13T06:23:16.912Z",
            productId: "string",
            updateTime: "2021-09-13T06:23:16.912Z",
          },
        ],
        productDescription: "productDescription",
        productId: "productId",
        productKeyWord: "",
        productLogistic: {
          createdTime: "2021-09-13T06:23:16.912Z",
          height: 0,
          length: 0,
          productId: "string",
          updatedTime: "2021-09-13T06:23:16.912Z",
          weight: 0,
          wide: 0,
        },
        productName: "productName",
        productPhotoList: [],
        productPrincipal: JSON.parse(localStorage.getItem("userInfo")).userId,
        productSku: "productSku",
        productSkuList: [
          {
            attributeList: [
              {
                attributeId: "string",
                attributeName: "string",
                attributeType: 0,
                attributeValue: "string",
                attributeValues: [
                  {
                    attributeId: "string",
                    attributeValue: "string",
                    attributeValueId: "string",
                    createdTime: "2021-09-13T06:23:16.912Z",
                    productId: "string",
                    updatedTime: "2021-09-13T06:23:16.912Z",
                  },
                ],
                createdTime: "2021-09-13T06:23:16.912Z",
                skuId: "string",
                updatedTime: "2021-09-13T06:23:16.912Z",
              },
            ],
            skuName: "string",
            createdTime: "2021-09-13T06:23:16.912Z",
            estimatedPurchasePrice: 0,
            inventory: 0,
            productId: "",
            skuId: "string",
            updatedTime: "2021-09-13T06:23:16.912Z",
          },
        ],
        productStatus: "CREATED",
        productUrl: "productUrl",
        purchaseCost: 0,
        salesStatus: "salesStatus",
        supplier: "supplier",
        updatedTime: "2021-09-13T06:23:16.912Z",
        warehouse: "warehouse",
      },
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      itemKey: 0,
      targetIndex: 0,
      logisticeByshop: [],
      checkedAlllogisctic: false,
      shoidForLogistics: null,
      rangeNumber: 20,
      ruleForm: {
        attributes: [
          {
            attributeId: "",
            attributeName: "",
            attributeType: "0",
            attributeValue: "",
            createdTime: "2021-09-14T07:53:17.203Z",
            productId: "",
            updatedTime: "2021-09-14T07:53:17.203Z",
          },
        ],
        productShops: [],
        categories: null,
        categoryId: 0,
        modelId: null,
        name: "",
        images: [],
        drag: false,
        status: "NORMAL",
        packageHeight: "",
        description: "",
        packageLength: "",
        country: "",

        packageWidth: "",
        weight: "",
        hasVariation: false,

        variations: [
          {
            name: "",
            price: "",
            stock: "",
            variationSku: "",
          },
        ],
        logistics: [],
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      rules: {
        name: [
          { required: true, message: this.$t('other.a1282'), trigger: "blur" },
          { min: 1, max: 255, message: this.$t('other.a1283'), trigger: "blur" },
        ],
        description: [
          { required: true, message: this.$t('other.a1284'), trigger: "blur" },
        ],
        categories: [
          { required: true, message: this.$t('other.a1285'), trigger: "blur" },
        ],
        variation: [{ required: true, message: this.$t('other.a1286'), trigger: "blur" }],
        weight: [{ required: true, message: this.$t('other.a1287'), trigger: "blur" }],
        variations: [
          { required: true, message: this.$t('other.a1288'), trigger: "blur" },
        ],
        isMandatory: [
          { required: true, message: this.$t('other.a1289'), trigger: "blur" },
        ],
        userValue: [
          { required: true, message: this.$t('other.a1282'), trigger: "blur" },
        ],
        psku: [{ required: true, message: this.$t('other.a1290'), trigger: "blur" }],
      },
      ruleForm1: {
        categories: null,
      },

      rules1: {
        categories: [
          { required: true, message: this.$t('other.a1285'), trigger: "blur" },
        ],
      },
      currentPage: -1,
      imageList: "",
      indexOne: 2,
      options: [],
      statusOptions: [
        {
          label: this.$t('other.a1291'),
          value: "NORMAL",
        },
        {
          label: this.$t('other.a1292'),
          value: "UNLIST",
        },
      ],
      value: "",
      categories: "",
      targetShopId: [],
      addAttribute: "",
      tableList: [],
      dialogVisible: false,
      showCaetgory: false,
      productName: "",
      active: 0,
      cateList: [],
      priceValue: "",
      stockValue: "",
      activeName: "ROOT",
      categoryList: [],
      secondCategory: [],
      thiryCategory: [],
      fourCategory: [],
      fiveCategory: [],
      categoryIdList: [],
      firstCategorylist: [
        {
          checked: true,
          checked02: false,
          name: this.$t('other.a1293'),
        },
      ],
      firstCategory: "",
      attributes: [],
      shopOptions: [],
      sitelist: [
        {
          label: this.$t('other.a1294'),
          value: "ROOT",
        },
        {
          label: this.$t('other.a1295'),
          value: "DXS",
        },
        {
          label: this.$t('other.a1296'),
          value: "PRO",
        },
      ],
      counstSite: [],
      radio: "",
      radio2: null,
      dialogVisible: false,
      pskuItem: null,
      getDataList: {
        component: true,
        cusCode: "",
        offset: 15,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem("userInfo")).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      wareOptions: [],
      storeValue: null,
      currentPage4: 1,
      tableCount: 0,
      searchCuscode: null,
      searchText: "",
      tierVariations: [],
      fabuProduct: false,
      addOthers: false,
      countryOption: [],
    };
  },

  components: {
    draggable,
  },

  inject: ["reload"],

  computed: {
    //这一部分直接拿过来用的
    ...mapState({
      ModelData: (state) => state.common.ModelData,
    }),

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },

    list() {
      let arr = [];
      for (let i = 0; i < 9; i++) {
        arr.push("");
      }

      return arr;
    },
  },

  watch: {},

  created() {
    this.getUserSuplist();
 let arr1 = [];
    let arr2 = [];
    JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
      if (p.isUsed) {
        if (p.storeType == 1) {
          arr1.push({
            label: p.storeName,
            value: p.storeId.toString(),
          });
        } else {
          arr2.push({
            label: p.storeName,
            value: p.storeId.toString(),
          });
        }
      }
    });
    this.warehouseOption = [...arr1, ...arr2];
    let id = this.$route.params.productId;
    console.log(id);
    this.handleEdit(id);
  },
  moutend(){
    
  },

  methods:{
    getUserSuplist() {
      api
        .getsuplist({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.supplierData = res.productSuppliers;
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取用户的供应商
    handleEdit(productId) {
      api
        .getpeodetail({
          productId: productId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              this.productDTO = res.productDetail;
              let num=this.productDTO.productPhotoList.length
                for(let i=0;i<num;i++){
                    this.ruleForm.images.push({
                        image:this.productDTO.productPhotoList[i],
                        positions:this.productDTO.productPhotoList.length+i
                    })
                }
              let arrnew = this.productDTO.productAttributes.map((item, index) => {
                return Object.assign(
                  {},
                  {
                    attributeId: item.attributeId.toString(),
                    attributeName: item.attributeName,
                    attributeType: item.attributeType.toString(),
                    attributeValue: item.attributeValue,
                    createdTime:"2021-09-13T06:23:16.912Z",
                    productId : item.productId.toString(),
                    updateTime : "2021-09-13T06:23:16.912Z"
                  }
                );
              });
              this.productDTO.productAttributes = arrnew;
              if(this.productDTO.productSkuList.length>0){
                  if(this.productDTO.productSkuList[0].skuName == this.productDTO.productSku){
                    this.radio = '1'
                  }else{
                    this.radio = '2'
                  }
                
              }else{
                this.radio = '1'
              }

          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    back(){
      this.$router.push({path:'/factorysupply/productLibrary'})
    },
    addattribute(){
        console.log(this.property)
        this.productDTO.productSkuList.push({
            attributeList : [],
            createdTime : "",
            estimatedPurchasePrice :0,
            inventory :0,
            productId : "",
            skuId : "",
            skuName : this.property,
            updatedTime :　""
        })
        this.property = '';
    },//添加规格
    addValue(){
        this.productDTO.productAttributes.push({
            attributeId : "",
            attributeName:"",
            attributeType:"0",
            attributeValue:"",
            createdTime:"2021-09-14T07:53:17.203Z",
            productId:"",
            updatedTime: "2021-09-14T07:53:17.203Z"
        })
    },//添加属性
    checkRule(){
        
        
        
    },
    immediatelyPublish(){
        console.log(this.ruleForm)
         if(this.ruleForm.country === 'ROOT'){
            this.$message.warning(this.$t('other.a1297'))
            return
        }
        if(this.activeName !== 'DXS'){
            if(this.ruleForm.productShops.length == 0){
                this.$refs.shopAndCategory.scrollIntoView()
                this.$message.warning(this.$t('other.a1298'))
                return
            }
        }
        if(!this.categories && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return
        }

        if(!this.ruleForm.attributes.length && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1300'))
            return
        }

        if(!this.ruleForm.weight  && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        let list2=[]
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push(p)
            }
        })

        if(!list2.length && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return
        }
        console.log(1417,this.ruleForm)
       
       
        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=this.logisticeByshop.filter(k => {
                k.logisticId=k.logistics_channel_id
                if(k.enabled){
                    return k
                }
            })
        }
        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList
        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                let newModel=res.data

                if(this.activeName == 'DXS'){
                    api
                    .publishProductToDXS({
                        productId:res.data.productId,
                        userId:this.userId,
                        online:true
                        
                    })
                    .then(res => {
                        if(res.code === 200){
                        this.$message.success(this.$t('other.a1303'))
                        }else{
                            this.$message.warning(res.msg)
                        }
                    })

                    return
                }
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            if(p.msg.indexOf('上架成功') > -1) {
                                this.$message.success(p.msg)
                            
                            }else{
                                this.$message.success(p.msg)
                                // api
                                // .deleteChildrenMoadel(newModel)
                                // .then(res => {
                                //     if(res.code === 200){
                                        
                                //     }
                                // })
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })
    },

    syncLogistics(){
        this.logisticeByshop=[]
        api
        .getShopLogisticsAndAttribute({shopId:this.targetShopId[0],categoryId:this.categoryIdList[this.categoryIdList.length-1]})
        .then(res => {
            if(res.code === 200) {
                console.log('物流和类目',res.data)
                let logistics=res.data.logistics
                let attributes=res.data.attributes
                logistics.forEach(k => {
                    k.checked=false 
                })

                this.logisticeByshop.push(...logistics)
                let obj1 = {};
                let res1 = [];
                this.logisticeByshop.forEach(k => {
                    if(!obj1[k.logisticId]){
                        res1.push(k)
                        obj1[k.logisticId]=true
                    }
                })

                this.logisticeByshop=res1
                console.log('logisticeByshop',this.logisticeByshop)
                this.$message.success(this.$t('other.a1304'))
                
            }
        })
        
    },

    getLoagistics(params){
        api
        .getShopLogisticsAndAttribute(params)
        .then(res => {
            if(res.code === 200) {
                console.log('物流和类目',res.data)
                let logistics=res.data.logistics
                let attributes=res.data.attributes

               
                attributes.forEach(p => {
                    p.userValue=''
                })
                console.log('rules',this.rules)
                attributes.forEach(p => {
                    p.optionsCopy=p.options
                })
                attributes.sort((a,b) => {
                    return a.attribute_name.charCodeAt(0)-b.attribute_name.charCodeAt(0)
                })
                this.attributes=attributes
                console.log('attributes',this.attributes)




                logistics.forEach(k => {
                    k.checked=false 
                })

                this.logisticeByshop.push(...logistics)
                let obj1 = {};
                let res1 = [];
                this.logisticeByshop.forEach(k => {
                    if(!obj1[k.logisticId]){
                        res1.push(k)
                        obj1[k.logisticId]=true
                    }
                })

                this.logisticeByshop=res1
                console.log('logisticeByshop',this.logisticeByshop)
               
           
               
            }else{
                this.$message.warning(res.msg)
            }
        })

        
    },

    loadMore(){
        return () => this.rangeNumber += 5
    },
    getDataType(price){
        let ttp=null
        if(price == '' || price == null || price == undefined){
            ttp=''
        }else{
            ttp=Number(price)
        }

        return ttp
    },

    changeValue(){
        console.log(this.ruleForm)
    },

    manageUser(){
       
        this.showCaetgory=true
    },
    handleClose(){
        this.showCaetgory=false
    },


    cateGory(item,index){
        console.log(item)
        if(index == 1){
           this.secondCategory=item.childrens
           this.thiryCategory=[]
           this.cateList[index-1]=item.categoryName
           this.categoryIdList[index-1]=item.categoryId
           this.cateList.splice(index,1)
           this.categoryIdList.splice(index,1)
           
        }else if(index == 2){
            this.thiryCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.cateList.splice(index,1)
            this.categoryIdList.splice(index,1)
        }else if(index == 3){
            this.fourCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 4){
            this.fiveCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 5){
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }


        this.categories=this.cateList.join(' / ')
        if(item.childrens == null){
            this.showCaetgory=false
            this.thiryCategory=[]
            this.fourCategory=[]
            this.secondCategory=[]
            this.fiveCategory=[]
            // this.getAttributesData()
            this.ruleForm.categoryId=this.categoryIdList[this.categoryIdList.length-1]    

        }

        console.log(this.ruleForm)
        console.log('categoryIdList',this.categoryIdList)
        console.log(this.cateList)
    },

    getAttributesData(){
        api
        .getAttributes({
            country:this.activeName,
            categoryId:this.categoryIdList[this.categoryIdList.length-1]

        })
        .then(res => {
            if(res.code == 200){
                console.log('品牌',res.data)
                res.data.forEach(p => {
                    p.userValue=''
                })
                console.log('rules',this.rules)
                res.data.forEach(p => {
                    p.optionsCopy=p.options
                })
                console.log(res.data)
                this.attributes=res.data
                console.log('attributes',this.attributes)
            }
        })
    },

    

    getShopId(){
        console.log(this.targetShopId)

        this.ruleForm.productShops= this.targetShopId.map(p => {
            return {
                shopId:p
            }
        })
    },

    dataFilter(item,index){
        console.log(item,index)
    },

    getShop(){
        const country={
            'TH':this.$t('other.a1305'),
            'PH':this.$t('other.a1306'),
            'ID':this.$t('other.a1307'),
            'MY':this.$t('other.a1308'),
            'TW':this.$t('other.a1309'),
            'VN':this.$t('other.a1310'),
          
        }
        let arr=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        let arr2=[]
        arr.forEach(p => {
            arr2.push(p.country)
       
        })

        arr2=[...new Set(arr2)]

        arr2.forEach(p => {
            this.sitelist.push({
                label:country[p],
                value:p
            })

        })

        console.log(this.sitelist)
       
        
        
    },

     

    delAttr(index,index02){
        console.log(index,index02)
        console.log(this.ruleForm)
         this.ruleForm.tiers[index].listItem.splice(index02,1)
        this.ruleForm.tiers[index].optionArray.splice(index02,1)
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])

        if(index === 0){//如果用户删除的第一级的属性
            let list1=[]
            let list2=[]
            this.ruleForm.variations.forEach((p,index) => {
                if(p.tierIndex[0] >= index02) {
                    if(p.tierIndex[0] !== index02){
                        p.tierIndex[0]-=1
                        list1.push(p)
                    }
                }else{
                    list2.push(p)
                }
            })

            this.ruleForm.variations=[...list2,...list1]
         
           console.log('list1',list1)
           console.log('list2',list2)

        }

        if(index === 1) {
           let num=0
           let list2=[]
           let list=this.group(this.ruleForm.variations,this.ruleForm.tiers[1].optionArray.length+1)

            list.forEach(p => {
                p.splice(index02,1)
            })

            list.forEach((i,) => {
                i.forEach((j,index) => {
                    j.tierIndex[1]=index
                    list2.push(j)
                })

                
            })
            this.ruleForm.variations=list2
            console.log('list2',list2)
           
            console.log('list',list)
        }

       
        
      
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
  },

    addOtherspp(index){
      
        this.ruleForm.tiers[index].listItem.push({
            name:this.ruleForm.tiers[index].firstCategory,
            checked02:false
        })
        this.ruleForm.tiers[index].optionArray.push(
            this.ruleForm.tiers[index].firstCategory
        )
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  
        console.log(this.ruleForm.tiers,index)
        this.ruleForm.tiers[index].firstCategory=''


        if(index == 0){
            console.log(this.ruleForm)
            console.log(index)
            let list=[]
            if(this.ruleForm.tiers.length > 1) {
                this.ruleForm.tiers[1].optionArray.forEach((i,index) => {
                    this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1,index],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1]+','+this.ruleForm.tiers[1].optionArray[index],
                        stock:'',
                        price:''
                    })
                })

                 console.log('list',list)
            }else{
                 this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1],
                        stock:'',
                        price:''
                    })
            }

           
           
        }

        if(index == 1){
            console.log(this.ruleForm)
            
            let list1=[]
            
            this.ruleForm.tiers[0].optionArray.forEach((p,index) => {
                let obj={
                    usCode:null,
                    price:'',
                    stock:'',
                    tierIndex:[index,this.ruleForm.tiers[1].optionArray.length-1],
                    variationSku:this.ruleForm.tiers[0].optionArray[index]+','+this.ruleForm.tiers[1].optionArray[this.ruleForm.tiers[1].optionArray.length-1]
                }
                list1.push(obj)
            })
            let count=this.ruleForm.tiers[1].optionArray.length-1
            let ttp=this.ruleForm.variations.length+count

            for(let i =count,j=0 ;i<ttp;i+=count,j++){
                
                console.log(i)
                this.ruleForm.variations.splice(i,0,list1[j])
                i++
            }
            console.log(this.ruleForm.variations)
            console.log('list1',list1)  
        }
    },
    
    delAttItem(index){
        this.$confirm(this.$t('other.a1311'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            this.ruleForm.tiers.splice(index,1)
        })
    },

    addAttibuteItem(){
        console.log(this.addAttribute)
        if(this.ruleForm.tiers.length == 2){
            this.$message.warning(this.$t('other.a1312'))
            return
        }else if(!this.addAttribute){
           
            return
        }
        this.ruleForm.tiers.push({
            name:this.addAttribute,
            listItem:[],
            optionArray:[],
            images:[],

        })

        this.addAttribute=''
    },

    publishProduct(){
        this.$confirm(this.$t('other.a1313'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            console.log(this.ruleForm)
            let obj=this.ruleForm.children.find(p => p.country === this.activeName)
            console.log(obj)
            api
            .publishProducts({
                productId:obj.productId
            })
            .then(res => {
                if(res.code === 200){
                    this.$message.success(this.$t('other.a1314'))
                }
            })
        })
    },

    getCategory(){
        console.log(this.activeName)
        this.shopOptions=[]
        this.targetShopId=[]
        let shoplist=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        shoplist.forEach(p => {
            if(p.country === this.activeName){
                this.shopOptions.push({
                    label:p.shopName,
                    value:p.shopId
                })
            }
        })

        console.log('shopOptions',this.shopOptions)

        let itemObj=this.counstSite.find(item => item.country == this.activeName)
        console.log(itemObj)
        if(itemObj !== undefined){
            this.ruleForm=itemObj
            if(this.ruleForm.variations.length > 0){
                this.ruleForm.radio='2'
               
            }else{
                this.ruleForm.radio='1'
               
            }
            this.targetShopId=this.ruleForm.productShops.map(p => {
                return p.shopId
            })

            console.log('targetShopId',this.targetShopId)
        }
        let num=9-this.ruleForm.images.length
        for(let i=0;i<num;i++){
            this.ruleForm.images.push({
                image:'',
                positions:this.ruleForm.images.length+i
            })
        }



        console.log('777',this.ruleForm)
          
        

        api
        .getCategoryByCountry({
            country:this.activeName,
        })
        .then(res => {
            if(res.code === 200){
                console.log('国家获取类目',res.data)
                let originListCopy=JSON.parse(JSON.stringify(res.data)) 
                this.categoryList=res.data
                if(this.ruleForm.categoryId){
                    console.log(this.ruleForm.categoryId)
                    this.ruleForm.country=this.activeName
                    let id=this.ruleForm.categoryId
                    let list=[]
                    this.categoryIdList=[]

                    originListCopy.forEach(p => {
                        p.childrens.forEach(k => {
                            if(k.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                            }else{
                                if(k.childrens !== null){
                                     k.childrens.forEach(i => {
                                    if(i.categoryId === id){
                                         list.push(p.categoryName)
                                         list.push(k.categoryName)
                                         list.push(i.categoryName)
                                         this.categoryIdList.push(p.categoryId)
                                         this.categoryIdList.push(k.categoryId)
                                         this.categoryIdList.push(i.categoryId)
                                    }
                                })
                                }
                               
                            }
                        })
                    })
                    console.log('list',list)
                    this.categories=list.join(' / ')

                    console.log(this.categoryIdList)
                    // this.getAttributesData()
                    
                    
                    
                }
              
               
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    createModel(){
        api
        .createProductModel({
            modelName:this.productName,
            userId:this.userId
        })
        .then(res => {
            if(res.code === 200){
                this.$message.success(this.$t('other.a1315'))
                console.log('创建的模版',res.data)

                this.options.push({
                    label:res.data.modelName,
                    value:res.data.modelId
                })
            }
        })
    },
    next() {
        if (this.active++ > 2) this.active = 0;
      },


    //信息填写的提示
    showTip(name,flag,text){
        let textone=text
        let flagone=flag
        console.log(flagone,flag)
        
        
        if(name == '' || name){
            this.$message.warning(textone)
            return
        }
    }, 
    addProducts(){
      
      let image = [];
      this.ruleForm.images.forEach((p)=>{
              image.push(p.image)
      })
      this.productDTO.productPhotoList = image;
      let arrnew = this.productDTO.productAttributes.map((item, index) => {
        return Object.assign(
          {},
          {
            attributeId: item.attributeId.toString(),
            attributeName: item.attributeName,
            attributeType: parseInt(item.attributeType),
            attributeValue: item.attributeValue,
            createdTime:"2021-09-13T06:23:16.912Z",
            productId : item.productId.toString(),
            updateTime : "2021-09-13T06:23:16.912Z"
          }
        );
      });
      this.productDTO.productAttributes = arrnew;
      this.productDTO.productAttributes.forEach((p)=>{
            p.attributeValues =[
                {
                attributeId:p.attributeId.toString(),
                attributeName:p.attributeName,
                attributeValue:p.attributeValue,
                attributeValueId:(p.productId+p.attributeId).toString(),
                createdTime:"2021-09-13T06:23:16.912Z",
                productId:p.productId.toString(),
                updatedTime:"2021-09-13T06:23:16.912Z"
            }
            ]
        })
      // this.ruleForm.images.forEach((p)=>{
      //   this.productDTO.productPhotoList.push(p.image)
      // })
         console.log(this.ruleForm);
        console.log(this.productDTO);
       api
        .updateproducts(this.productDTO)
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
             this.$message.success(this.$t('other.a665'));
            setTimeout(() => {
              this.$router.push({path:'/factorysupply/productLibrary'})  
            }, 2000);
            
           
          } else {
            this.$message.warning(res.msg);
          }
        });
        
    },//添加到产品库

    publishAndsave(){//保存并立即发布
        console.log(this.sitelist)
        if(this.activeName == 'ROOT'){
            this.$message.warning(this.$t('other.a1316'))
            return
        }

    
        if(this.ruleForm.productShops.length == 0){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1298'))
            return
        }

        if(!this.categories){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return
        }

        if(!this.ruleForm.attributes.length ){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price ){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1317'))
            return
        }

        if(!this.ruleForm.weight ){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }

        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        let list2=[]
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push(p)
            }
        })
        if(!list2.length){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return
        }
        
       
       
        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=this.logisticeByshop.filter(k => {
                if(k.enabled){
                    return k
                }
            })
        }
        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList

        this.ruleForm.modelId=this.$route.query.idModel
        this.ruleForm.productId=null

        console.log(1417,this.ruleForm)

        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            this.$message.success(p.msg)
                            if(p.msg.indexOf('上架成功') > -1) {
                              
                              setTimeout(() => {
                                   location.replace('/templateManagement')
                              },500)
                            }else{
                                
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })

    },

    cancel(){
        this.$router.push('/templateManagement')
    },

    pushAttribute(){
        console.log(this.attributes,this.rangeNumber)
        let list=this.attributes.map(p => {

            let ttp=p.unit ? p.unit : ''
            return {
                attributeId:p.attribute_id,
                attributeName:p.attribute_name,
                attributeValue:p.userValue + ttp,
                isMandatory:p.is_mandatory

            }
        })
        

        this.ruleForm.attributes=list
        console.log(this.ruleForm)
    },

    // back(){
    //     this.$router.push({
    //         path:this.$route.query.from
    //     })
    // },

  
    


    setPrice(num){
       console.log(this.ruleForm)
       if(this.priceValue == '' || this.priceValue == null){
          this.$message.warning(this.$t('other.a1318'))
          return
       }
       if(num == 1){
              this.productDTO.productSkuList.forEach(p => {
                    p.estimatedPurchasePrice=this.priceValue
                })
       }else if(num == 2){
           this.ruleForm.variations.forEach(p => {
                    p.inventory=this.stockValue
                })
       }
    
       
    },

    addItmes(num,index){
        if(num ==0) {
            this.ruleForm.variations.push({
                name:'',
                price:'',
                stock:'',
                variationSku:'',
            })
        }else{
            this.ruleForm.variations.splice(index,1)
        }
    },

    findItem(item,index,e){
        console.log(index)
        this.targetIndex=index
        var str = this.$refs.searchSelect[index].$data.selectedLabel

        console.log(str)
        this.searchText=str
    },

    deleteImg(index){
        //  this.$set(this.ruleForm.images,index,'')
         this.ruleForm.images[index].image=""
         console.log(this.ruleForm.images);
    },
    vkfb(item,index){
         console.log(item)
         item.checked02=true
         this.$set(this.ruleForm.tiers,index,item)  
    },

    onhv(item,index,index02){
        item.checked02=true
        
        this.$set(this.ruleForm.tiers[index],index02,item)  
    },

    fixAttr(item,index,index02){
        console.log(item,index,index02)
        item.checked02=false

        this.ruleForm.tiers[index].optionArray[index02]=item.name
        this.ruleForm.tiers[index].listItem[index02].name=item.name
        this.ruleForm.tiers[index].listItem[index02].checked02=false
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  

         console.log(this.ruleForm.tiers)
        this.itemKey=Math.random()
    },

    confirmvkfb(item,index){
         console.log(item,index)
         item.checked02=false
         this.$set(this.ruleForm.tiers,index,item)  
    },

    goBack(){
        this.$router.push('/alliance/singleGoods')
    },
    showDelBtn(index){
        console.log(index)
        this.currentPage=index
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        document.getElementById("initSlide").dispatchEvent(e);

    },
    hiddenDelBtn(){},
    deleImg(){},

    handlePictureSuccess(response, file, fileList){
        console.log('file',file)
    },

    getCurrentRow(item){
        console.log(item)
        this.pskuItem=item
    },

    banding(item,storeId){
        api
        .getStoreItemByGroup({
            itemSku:item,
            userId:this.userId
        })
        .then(res => {
            if(res.code === 200){
                console.log('仓库物品信息',res.data)

                if(res.data.length > 1 ){
                  res.data.forEach(p => {
                      p.storeItems.forEach(k => {
                          if(!p.image ){
                              p.image=p.storeItems[0].image
                          }
                      })
                  })
                  this.tableList=res.data
                  this.dialogVisible=true
         
                    return
                }
                let num=0
                if(res.data.length ==1){
                    if(!this.ruleForm.variations.length){
                        this.ruleForm.groupId=res.data[0].groupId
                    }
                    if(this.ruleForm.variations.length>0){
                        this.ruleForm.groupId=res.data[0].groupId
                        this.ruleForm.variations.forEach((k,index) => {
                            k.cusCode=null
                            let options=res.data[0].storeItems.map(p => {
                                return {
                                    value:p.cusCode,
                                    label:p.skuName
                                }
                            })
                            options.unshift({
                                label:this.$t("other.a140"),
                                value:null
                            })
                            this.$set(k,'options',options)
                            
                            res.data[0].storeItems.forEach(j => {
                                if(j.skuName == k.variationSku){
                                    k.cusCode=j.cusCode
                                } 
                            })

                            if(!k.cusCode){
                                k.cusCode=this.$t('other.a1319')
                            }
                            if(k.cusCode ==this.$t('other.a1319')){
                                num +=1
                            }
                          
                        })
                           
                    }
                }

                if(num){
                    let desc=this.$t('other.a1320')+num+this.$t('other.a1321')
                        this.$confirm(desc,this.$t("other.a142"),{
                            confirmButtonText:this.$t("other.a884"),
                            cancelButtonText: this.$t('other.a146'),
                            type: 'warning'
                        }).then(() => {
                           
                        })
                }

                console.log(this.ruleForm)
                
            }
        })
    },

    handleByuser(){
        this.wareOptions=[]
        this.dialogVisible=true

        let warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {return p.isUsed ==true})
        console.log('warehouseList',warehouseList)
        warehouseList.forEach(p => {
            this.wareOptions.push({
                label:p.storeName,
                value:p.storeId
            })
        })

        console.log(warehouseList)

        this.storeValue=warehouseList[0].storeId
        this.getDataList.storeId=this.storeValue
        this.getStoreItem()
    },

    getStoreItem(){
        userStoreItemsApi
        .getStoreItem(this.getDataList)
        .then(res => {
            if(res.code === 200) {
                console.log('获取用户模版信息',res.data)
                res.data.groups.forEach(p => {
                    p.checked=false
                    if(!p.image){
                        p.image=p.storeItems[0].image
                    }
                })
                this.tableList=res.data.groups
                this.tableCount=res.data.count
            }
        })
    },

    submitPsku(){

        console.log(this.pskuItem)
        console.log(this.ruleForm)
        this.ruleForm.itemSku=this.pskuItem.itemSku
        if(!this.ruleForm.variations || this.ruleForm.variations.length == 0){//单规格 

        }else{//多规格 
             this.dialogVisible=false
                this.ruleForm.groupId=this.pskuItem.groupId
                let num=0
                this.ruleForm.variations.forEach((k,index) => {
                    k.cusCode=null
                    let options=[{
                        label:this.$t("other.a140"),
                        value:null
                    }]
                    this.pskuItem.storeItems.forEach(p => {
                        options.push({
                            value:p.cusCode,
                            label:p.skuName ? p.skuName : this.$t('other.a1322')
                        }) 
                    })
                 
                    this.$set(k,'options',options)
                    
                    this.pskuItem.storeItems.forEach(j => {
                        if(j.skuName == k.variationSku){
                            k.cusCode=j.cusCode
                        } 
                    })

                    if(!k.cusCode){
                        k.cusCode=null
                    }
                    if(!k.cusCode ){
                        num +=1
                    }
                    
                })
        }
       
    },

    handleUploadHttpRequest(params){
        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)

        if(!isLt2M){
            this.$message.error(this.$t("other.a332"));
            return false;
        }

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.imageList=res.data
                this.$set(this.ruleForm.images,this.currentPage,{
                    image:res.data,
                    positions:this.currentPage

                })
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    //shopee采集过来的商品，编辑时调用此方法
    scrapedDataByshopee(data){
         this.ruleForm=data
            this.tierVariations=[]
             if(data.tiers.length){
                //属性分类
                data.tiers.forEach(p => {
                    this.tierVariations.push({
                        name:p.name,
                        tierVariations:'',
                        firstCategory:'',
                        optionArray:p.optionArray.map(i => {
                            return {
                                name:i,
                                checked:true,
                                checked02:false
                            }
                        })
                    })   
                })

                this.ruleForm.variations.forEach((p,index) => {
                    p.firstName=this.tierVariations[0].optionArray[p.tierIndex[0]].name
                    if(data.tiers.length > 1){
                        p.secondName=this.tierVariations[1].optionArray[p.tierIndex[1]].name
                    }
                })
            }

             if(this.ModelData.variations.length > 0){//多规格
                this.radio='2'
            }else{//单品
                this.radio='1'
            }
            console.log('tierVariations',this.tierVariations)
            console.log('741',this.ruleForm)
    },
    init(){
        for(let i=0;i<9;i++){
            this.ruleForm.images.push({
                image:'',
                positions:i
            })
        }
        this.countryOption=utils.getCountryOption()
       

         if(this.$route.query.addOthers){//新增商品
          this.ModelData.status=null
           this.addOthers=true
           this.ModelData.condition="NEW"
            this.ModelData.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
           console.log('774852',this.ModelData)
           this.scrapedDataByshopee(this.ModelData)
           
        }

        if(this.$route.query.productId){//编辑
         this.addOthers=true
         this.ModelData.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
            console.log(this.$route.query.productId)
           
            console.log('model',this.ModelData)


            const code={
                'TH':this.$t('other.a1305'),
                'PH':this.$t('other.a1306'),
                'ID':this.$t('other.a1307'),
                'MY':this.$t('other.a1308'),
                'TW':this.$t('other.a1309'),
                'VN':this.$t('other.a1310'),
            }

            this.ruleForm=this.ModelData
            // if(this.ModelData.variations.length > 0){//多规格
            //     this.radio='2'
            // }else{//单品
            //     this.radio='1'
            // }
            console.log('ModelData',this.ruleForm)

            // this.active=2
            // this.sitelist=[{
            //     label:this.$t('other.a1294'),
            //     value:'ROOT'
            // },{
            //     label:this.$t('other.a1295'),
            //     value:'DXS'
            // }]
            // this.sitelist.push({
            //     label:code[this.ModelData.country 
            //     ] + this.ModelData.productId,
            //     value:this.ModelData.country,
            // })
            // this.counstSite=[{
            //     country:'ROOT',
            //     value:this.ModelData
            // }]
            this.counstSite.push(this.ModelData)
             console.log('ModelData',this.ModelData)
             console.log('counstSite',this.counstSite)

             
           
        }else{
            this.getShop()
        }

        if(this.$route.query.itemId){//线上导入
              let itemId=this.$route.query.itemId
                if(itemId !== undefined){
                    api
                    .getItemAttribute({itemId})
                    .then(res => {
                    if(res.code === 200) {
                        console.log('itemId',res.data)
                        this.ruleForm.categoryId=res.data.item.categoryId
                        this.ruleForm.name=res.data.item.name
                        this.ruleForm.packageHeight=res.data.item.packageHeight
                        this.ruleForm.packageLength=res.data.item.packageLength
                        this.ruleForm.packageWidth=res.data.item.packageWidth
                        this.ruleForm.itemId=res.data.item.itemId
                        this.ruleForm.hasVariation=res.data.item.hasVariation
                        this.ruleForm.cusCode=res.data.item.cusCode
                        this.ruleForm.shopee=res.data.item.shopee
                        this.ruleForm.sales=res.data.item.sales
                        this.ruleForm.condition='NEW'
                        this.ruleForm.itemSku=res.data.item.itemSku
                        this.ruleForm.weight=res.data.item.weight
                        this.ruleForm.description=res.data.item.description
                        res.data.images.forEach(p => {
                            this.ruleForm.images[p.positions].image=p.image
                        })
                        this.ruleForm.variations=[]

                        if(res.data.item.hasVariation && res.data.item.variations !== null){//如果有variations,多规格
                            this.radio="2"
                            this.ruleForm.hasVariation=true
                                res.data.item.variations.forEach(p =>{
                                    this.ruleForm.variations.push({
                                        name:p.name,
                                        price:p.price,
                                        stock:p.stock,
                                        variationSku:p.variationSku
                                    })
                            })
                        }else{//单品
                            this.radio="1"
                            this.ruleForm.hasVariation=false
                            this.ruleForm.stock=res.data.item.stock,
                            this.ruleForm.price=res.data.item.price,
                            this.ruleForm.itemSku=res.data.item.itemSku
                     
                        }
                        this.ruleForm.logistics=res.data.logistics
                        console.log('tt',this.ruleForm)
                    
                    }
                })
                }
       
        }

        // 分销仓或联盟仓发布商品
        if(this.$route.query.id){
            this.fabuProduct=true
            api
            .getProductByproductId({
                productId:this.$route.query.id
            })
            .then(res => {
                if(res.code === 200){
                    let storeItems=JSON.parse(localStorage.getItem('storeItems'))
                    if(storeItems){
                        res.data.variations.forEach(p => {
                            p.options=storeItems
                        })
                    }
                    console.log(res.data)
                    res.data.tiers.forEach(k => {
                        k.checked02=false
                        k.listItem=k.optionArray.map(k => {
                            return {
                                name:k,
                                checked02:false
                            }
                        })
                    })
                    res.data.userId=this.userId
                    res.data.productShops=[]
                    res.data.country="ROOT"
                    res.data.productId=null
                    res.data.items=[]
                    res.data.variations.forEach(p => {
                        p.cost=this.$t('other.a1323')+ p.price +this.$t('other.a1324')
                        p.price=null
                        p.cusCode=p.options.find(item => item.label == p.variationSku).value
                    })
                    console.log(res.data)
                    this.ruleForm=res.data
                    if(res.data.variations.length > 0 ){//如果有variations,多规格
                        this.radio="2"
                        
                    }else{//单品
                        this.radio="1"
                    }
                }
            })
        }

      
    },

    //控制每页显示订单条数
    handleSizeChangeStore(val) {
                        console.log(`每页 ${val} 条`);
                        this.offset=parseInt(`${val}`)
                        this.getDataList.offset=parseInt(`${val}`)
                        this.handleCurrentChangeStore()
        },
        //显示当前第几页
        handleCurrentChangeStore(val) {
                this.radio2=null
                this.currentPage4=parseInt(`${val}`)
                this.getDataList.page=(parseInt(`${val}`) -1) * this.getDataList.offset
               

                this.getStoreItem()
                    
        },

        search(){
            this.radio2=null
            this.getDataList.cusCode=this.searchCuscode
            this.getStoreItem()
        }
    
}
};
</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.productionModel {
  background-color: #eee;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 60px;

  .kvnnf {
    height: 20px !important;
    padding: 0 5px;
  }

  /deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
  }

  .el-icon-edit {
    font-size: 18px;
    cursor: pointer;
  }

  .el-icon-check {
    font-weight: bold;
    font-size: 18px;
    color: #40d3f2;
    margin: 0 8px;
    cursor: pointer;
  }
  .icon-gouSolid-copy {
    font-size: 22px;
    margin: 0 15px;
    color: rgb(42, 165, 21);
  }

  .footer {
    position: fixed;
    background-color: #fff;
    width: 86%;
    bottom: 0;
    height: 70px;
    margin-left: -20px;
    border-top: 1px solid #eee;
    z-index: 15;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-shadow: 5px ​4px 23px -6px #606266;
  }

  .basic_info {
    background-color: #fff;
    padding: 0 16px;
    margin-bottom: 25px;

    /deep/.el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }

    /deep/.el-tabs__item {
      font-size: 20px;
    }

    .attribute {
      min-width: 350px;
      box-sizing: border-box;
      margin-bottom: 10px;

      .attribute_desc {
        display: inline-block;

        text-align: right;
      }
    }

    .title {
      height: 68px;
      line-height: 68px;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.02em !important;
      font-family: Roboto, sans-serif !important;
      border-bottom: 1px solid #eee;
    }

    .basic_detail {
      padding: 15px 0;

      .singSku_wrapper {
        display: flex;

        .singSku {
          display: flex;
          margin-right: 30px;

          .inputBox {
            display: inline-block;
            width: 180px;
          }
        }
      }

      .attribute {
        width: 100%;
        height: auto;

        box-sizing: border-box;
        padding: 5px 10px;

        .fist_title_wrapper {
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          .fist_title {
            font-weight: bold;
            font-size: 18px;
          }
        }

        .category_item {
          margin: 0 15px;

          .el-icon-circle-close {
            font-weight: bold;
            font-size: 18px;
            color: red;
            margin: 0 8px;
            cursor: pointer;
          }

          .el-icon-edit {
            cursor: pointer;
          }
        }

        .el-icon-edit {
          padding: 0 10px;
        }
      }
    }

    .listitem {
      display: inline-block;
      width: 120px;
      height: 120px;
      border-radius: 3px;
      cursor: pointer;
      border: 1px dashed #c0ccda;
      margin: 0 5px;
      position: relative;
    }

    .pic_desc {
      position: absolute;
      bottom: -45px;
      left: 40px;
    }

    .cateGory_wrapper {
      position: relative;
      box-shadow: 0 5px 5px -3px #606266;
      height: 450px;

      .first_wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .first_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .second_wrapper {
        position: absolute;
        top: 0;
        left: 200px;
        width: 200px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .second_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .three_wrapper {
        position: absolute;
        top: 0;
        left: 400px;
        width: 200px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .three_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .four_wrapper {
        position: absolute;
        top: 0;
        left: 600px;
        width: 200px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .four_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .five_wrapper {
        position: absolute;
        top: 0;
        left: 800px;
        width: 200px;
        height: 450px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;

        .five_category {
          cursor: pointer;
          padding: 0 10px;
          border-bottom: 1px solid #eee;
        }
      }

      .category_title {
        position: relative;
        top: 0;
        left: 0;
      }

      .active {
        background-color: #fff;
      }

      .active:hover {
        background-color: #eee;
      }
    }

    .pic_box {
      width: 120px;
      height: 120px;
      position: absolute;
      z-index: 2;
    }

    .listitem::after {
      content: "+";
      font-size: 40px;

      position: absolute;
      top: 48px;
      left: 48px;
      z-index: 1;
    }

    .delete {
      width: 120px;
      background-color: rgba(0, 0, 0, 0.87);
      color: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: center;
      display: none;
      z-index: 99;
    }

    .deleteActive {
      display: block;
      z-index: 99;
    }

    .icon-zengjiatianjiajiajian {
      color: rgb(64, 211, 242);
      cursor: pointer;
      font-size: 20px;
    }

    .icon-jianshao1 {
      color: rgb(246, 97, 109);
      cursor: pointer;
      font-size: 20px;
    }
  }
}
</style>